import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

export default function ExerciseIcon({ size = 40, withCircle = true, color }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 40 40";
  const iconTransform = withCircle ? "" : "translate(-20 -20)";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.2555 37.4787C51.0636 37.4787 51.6888 36.8505 51.6888 36.0456C51.6888 35.2375 51.0612 34.6117 50.2555 34.6117H47.0295C46.6255 34.6117 46.2679 34.3876 46.088 34.0751L43.3103 29.2329C42.8179 28.3812 41.8766 27.7999 40.8894 27.7999C40.1285 27.7999 39.3648 28.1123 38.8724 28.6522L32.3704 34.7893C31.878 35.2817 31.5181 36.0456 31.5181 36.8063C31.5181 37.8827 32.3262 38.7347 33.1761 39.2271L38.1067 42.2764C38.5107 42.5005 38.7348 42.9488 38.7348 43.397V48.9551C38.7348 49.7633 39.3621 50.3888 40.1679 50.3888C40.976 50.3888 41.6018 49.7609 41.6018 48.9551V40.9759C41.6018 40.5721 41.4219 40.2146 41.1088 39.9439L38.4191 37.7469C38.195 37.5676 38.195 37.2545 38.375 37.0746L41.5126 33.8483C41.6925 33.6245 42.0497 33.6687 42.2291 33.8928L44.2909 36.9418C44.5171 37.2987 44.8767 37.4787 45.2366 37.4787H50.2555Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.813 26.4602C50.813 24.5261 49.2629 23 47.3526 23C45.4422 23 43.8921 24.5261 43.8921 26.4602C43.8921 28.3921 45.3877 29.9209 47.3526 29.9209C49.3174 29.9209 50.813 28.3948 50.813 26.4602"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.3515 40.3872C46.5751 40.3872 42.7029 44.2594 42.7029 49.0358C42.7029 53.8125 46.5751 57.6845 51.3515 57.6845C56.1282 57.6845 60.0001 53.8125 60.0001 49.0358C60.0001 44.2594 56.1282 40.3872 51.3515 40.3872M51.3515 42.759C54.8128 42.759 57.6285 45.575 57.6285 49.036C57.6285 52.4974 54.8128 55.313 51.3515 55.313C47.8904 55.313 45.0744 52.4974 45.0744 49.036C45.0744 45.575 47.8904 42.759 51.3515 42.759"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.6486 40.3872C23.8719 40.3872 20 44.2594 20 49.0358C20 53.8125 23.8719 57.6845 28.6486 57.6845C33.425 57.6845 37.2973 53.8125 37.2973 49.0358C37.2973 44.2594 33.425 40.3872 28.6486 40.3872M28.6486 42.759C32.1097 42.759 34.9257 45.575 34.9257 49.036C34.9257 52.4974 32.1097 55.313 28.6486 55.313C25.1873 55.313 22.3716 52.4974 22.3716 49.036C22.3716 45.575 25.1873 42.759 28.6486 42.759"
          fill={color}
        />
      </g>
    </Svg>
  );
}
